import { useMutation } from "@tanstack/react-query";
import { dfetch } from "src/utils/dfetch.ts";

/** Optional scope for a run-insights request; omit all for a global run. */
export type RunInsightsScope = {
  tenant_id?: number;
  env_id?: number;
  app_id?: number;
};

/** GET `/api/single-admin-actions/run-insights` */
export const useRunInsightsMutation = () => {
  return useMutation({
    mutationFn: (scope?: RunInsightsScope) =>
      dfetch("/api/single-admin-actions/run-insights", scope, "GET").invalidate(),
  });
};
